// @ts-nocheck
//Smooth Scroll
import { Link } from 'react-scroll';

// レイアウト
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function F_biztrip() {

  return (
    <div className="facility-lower">
      <h2 className="tag-title">出張</h2>
      <Row className="toc-btnArea">
        <Col sm={4} className='toc-btn'>
          <Link
            to="chapter01"
            smooth={true}
            duration={500}
            offset={-100}
            className='btn main-btn type-internal w-100'
          >
            出張手配について
          </Link>
        </Col>
        <Col sm={4} className='toc-btn'>
          <Link
            to="chapter02"
            smooth={true}
            duration={500}
            offset={-100}
            className='btn main-btn type-internal w-100'
          >
            出張日当について
          </Link>
        </Col>
      </Row>
      <section className="sec-biztrip">
        <h3 id="chapter01" className='icon-title type-pencil'>出張手配について</h3>
        <div className="border-box">
          <p className="todo-catch"><span>To Do</span>出張手配の前に「購入稟議」と「出張申請」の申請が必要です。</p>
          <p className="todo-catch todo-nothing"><a href="https://sites.google.com/zenken.co.jp/contracts-regulations/regulations/regulations_related_to_personnel_and_labor_affairs/%E5%87%BA%E5%BC%B5%E6%97%85%E8%B2%BB%E8%A6%8F%E7%A8%8B%E5%88%A5%E8%A1%A8" target="_blank" class="text-link type-external">「出張旅費規程」</a>の範囲内で申請をしてください。</p>
          出張手配の詳細は、以下の資料からご確認ください。
          <iframe src="https://docs.google.com/presentation/d/1xzEhOXCQ8biRGRm-3EiJB-HHTLS8fOEAYx8eWqSvPzw/preview" width="800" height="490" allow="autoplay"></iframe>
        </div>

        <h3 id="chapter02" className='icon-title type-pencil'>出張日当について</h3>
        <div className="border-box">
          <p className="todo-catch"><span>To Do</span>日当については下記の表をご確認ください。</p>
        </div>
        <div className="img-wrap ct">
          <div className="flame">
            <img
              src={process.env.PUBLIC_URL + '/facility_pic/biztrip02.jpg'}
              alt="出張日当について"
              className="img-wrap__img"
            />
          </div>
        </div>
      </section>

    </div>

  );
}

export default F_biztrip;

